import script from "./ReactivateSubscriptionConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactivateSubscriptionConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./ReactivateSubscriptionConfirmModal.vue?vue&type=style&index=0&id=39152ed1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39152ed1"]])

export default __exports__